import axios, { updateAuthToken } from '@/src/api/axios_init'
import { authControllerSelfUpdatePassword } from '@/src/api/types/generated-types'

export const PASSWORD_RESET = '/auth/reset-password'
export const PASSWORD_RESET_EMAIL = '/auth/reset-password/email'
export const AUTH_LOGIN = '/auth/login'
export const SSO_AUTH_LOGIN = '/auth/login/sso'
export const SSO_AUTH_SIGNUP = '/auth/signup/sso'
export const TOKEN_LOCAL_STORAGE = 'token'

export const authenticate = async (email: string, password: string) => {
  const response = await axios.post(AUTH_LOGIN, {
    email: email,
    password: password,
  })
  const token = response.data.token
  updateAuthToken(token)

  return response
}

export const sendPasswordResetEmail = async (email: string) => {
  return axios.post(PASSWORD_RESET_EMAIL, { email })
}

export const resetUserPassword = async (uid: string, password: string, token: string) => {
  return axios.patch(PASSWORD_RESET, { password, uid, token })
}

export const updateOwnPassword = async (currentPassword: string, newPassword: string) => {
  return authControllerSelfUpdatePassword({ requestBody: { currentPassword, newPassword } })
}
